export default "__VITE_ASSET__D63ZICPI__"